export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";